export const createHeaders = (token?: string) => {
	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Accept", "application/json");
	if (token) {
		headers.append("authorization", `Bearer ${token}`);
	}
	headers.append("Origin", origin);
	return headers;
};
